import { render, staticRenderFns } from "./UserVisaTransactions.vue?vue&type=template&id=3e736b7a&"
import script from "./UserVisaTransactions.vue?vue&type=script&lang=js&"
export * from "./UserVisaTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports